<template>
	<div class="itemContainer" :class="[!link ? 'borderless' : '', edit ? 'itemEdit' : '']">
		<div class="text" :class="snippetClass" v-show="link != 'borderless' || edit">
			<div v-if="link != '' || edit" class="link-item-header" :class="[readMoreIsClosed ? 'itemClosed' : 'itemOpen', edit? 'editMode' : '']" @click="readMoreIsToggled">
				<h3>
					{{$t(header)}} <span class="required" v-show="required && edit">*</span>
					<ExtraInfo :id="header" v-if="edit"></ExtraInfo>
				</h3>
				<ReadMoreButton :expanded="!readMoreIsClosed" @toggle="readMoreIsToggled" v-if="!edit" />
			</div>
			<div :id="header" v-if="edit">
				<input v-model="link" @change="change" @input="onDirty" @onblur="onBlur" />
			</div>
			<transition name="roll">
				<div v-if="!readMoreIsClosed">			
					<div v-if="!edit && !readMoreIsClosed" class="linkitem-text, link-item-container">
						<a v-if="text.split(';#;')[1] != ''" class="details link" :href="text.split(';#;')[1]" target="_blank">{{text.split(";#;")[0]}}</a>
						<span v-else>{{text.split(";#;")[0]}}</span>
					</div>			
					<div v-else class="link-item-container" v-show="!readMoreIsClosed">
						<a class="details link" :href="text.split(';#;')[1]" target="_blank">{{$t(header)}} {{text.split(";#;")[0]}}</a>
					</div>
				</div>
			</transition>
			<div v-if="edit" class="spacer"></div>
		</div>
	</div>
</template>

<script>
        /*eslint-disable */
import Item from "../../mixins/Item.js";
import ReadMore from "common/components/General/ReadMoreHeight";
import ExtraInfo from "./ExtraInfo";
import ReadMoreButton from "./ReadMoreButton.vue";

export default {
	name: "link-item",
	components: {
		ReadMore, 
		ExtraInfo, 
		ReadMoreButton
	},
	mixins: [Item],
	props: {
		required: Boolean
	},
	data: function() {
		return {
			text: "",
			link: "",
			readMoreIsClosed: true
		};
	},
	methods: {
		change(){
			var model = this;
			this.onDirty();
			this.text = this.text.split(';#;')[0] + ";#;" + this.link;
			this.$emit("change", model.header, model.link);
		},
		onBlur() {
            this.$emit("blur");
		},
		onSave() {
			this.revert = this.text;
		},
		toOriginal() {
            this.text = this.revert;
			this.link = this.revert.split(';#;')[1]
		},
		readMoreIsToggled(){
			this.readMoreIsClosed = !this.readMoreIsClosed;
		}
	},
	computed: {
		snippetClass() {
			return this.edit ? `${this.$i18n.locale}` : "";
		},
	},
        created() {

            this.link = this.text.split(';#;')[1];
	}
};
</script>
<style lang="less" scoped>
@import "../../assets/item.less";

.link-item-header:not(.editMode) {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px;
	transition: background-color 0.3s ease;
	cursor: pointer;
	user-select: none;
}

.link-item-header:not(.editMode):hover,
.link-item-header:not(.editMode).itemOpen {
	background-color: #f2f1f8;
}

.link-item-header h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 0px;
}

@media (max-width: 768px) {
	.link-item-header h3 {
		font-size: 14px;
	}
}

.link-item-container {
	padding: 0px 16px 24px 16px;
	background-color: #F2F1F8;  
}

.link-item-container a {
	vertical-align: middle;
	text-decoration: none;
}

.link-item-container a:hover {
	color: #351FB7;
}

.link::before {
	background: url("../../images/link.svg");
	content: "";
	display: inline-block;
	background-size: 24px 24px;
	width: 24px;
	height: 24px;
	vertical-align: middle;
	margin-right: 6px;
}
.spacer {
	height: 28px;
}
</style>
<style lang="less">
.roll-enter-active,
.roll-leave-active {
  transition: all 300ms ease;
}

.roll-enter,
.roll-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
